module.exports = __webpack_public_path__ + "static/media/Ms-Jollie-Regular.4ab5f4ab.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ms-Jollie-Regular.woff
// module id = 3324
// module chunks = 70